import React, { useEffect, useState } from "react";
import { Card, Row, Col, CardBody } from "reactstrap";
import { api } from "../../../../config";
import { getEnviromentalParameterData } from "../../../../helpers/data_sped/backend_helper";

const LeftSummaryWidget = ({ code_siep, h100 = true }) => {
  const [temperatureData, setTemperatureData] = useState(null);
  const [salinityData, setSalinityData] = useState(null);
  const [oxygenData, setOxygenData] = useState(null);
  const [dissolvedOxygenData, setDissolvedOxygenData] = useState(null);
  // const [loading, setLoading] = useState(true);

  function calculateDifference(current, previous) {
    if (current == null || previous == null) return { difference: null, positive: null };
    const diff = current - previous;
    return {
      difference: (diff >= 0 ? "+" : "") + diff.toFixed(1),
      positive: diff >= 0
    };
  }

  useEffect(() => {
    if(!['', null].includes(api.REACT_APP_SPED_ORIGINAL_API_URL)){

      const today = new Date();
      const previousWeek = new Date(today);
      previousWeek.setDate(today.getDate() - 7);
      const dateToday = today.toISOString().split('T')[0];
      const datePreviousWeek = previousWeek.toISOString().split('T')[0];


      const loadData = async () => {
          const [
            responseTemperature,
            responseTemperaturePrevious,
            responseOxygen,
            responseOxygenPrevious,
            responseDissolvedOxygen,
            responseDissolvedOxygenPrevious,
            responseSalinity,
            responseSalinityPrevious
          ]= await Promise.all([
            getEnviromentalParameterData(
              code_siep,
              'Temperatura',
              null,
              dateToday,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Temperatura',
              null,
              datePreviousWeek,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Oxígeno',
              null,
              dateToday,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Oxígeno',
              null,
              datePreviousWeek,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Saturación',
              null,
              dateToday,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Saturación',
              null,
              datePreviousWeek,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Salinidad',
              null,
              dateToday,
              '24h'
            ),
            getEnviromentalParameterData(
              code_siep,
              'Salinidad',
              null,
              datePreviousWeek,
              '24h'
            )
          ]);

          const currentTemperature = responseTemperature?.data[0]?.value;
          const previousTemperature = responseTemperaturePrevious?.data[0]?.value;

          const currentOxygen = responseOxygen?.data[0]?.value;
          const previousOxygen = responseOxygenPrevious?.data[0]?.value;

          const currentDissolvedOxygen = responseDissolvedOxygen?.data[0]?.value;
          const previousDissolvedOxygen = responseDissolvedOxygenPrevious?.data[0]?.value;

          const currentSalinity = responseSalinity?.data[0]?.value;
          const previousSalinity = responseSalinityPrevious?.data[0]?.value;

          // Calculate differences
          const temperatureDiff = calculateDifference(currentTemperature, previousTemperature);
          const oxygenDiff = calculateDifference(currentOxygen, previousOxygen);
          const dissolvedOxygenDiff = calculateDifference(currentDissolvedOxygen, previousDissolvedOxygen);
          const salinityDiff = calculateDifference(currentSalinity, previousSalinity);

          // Create the mock-like data objects
          const temperatureData = {
            value: currentTemperature.toFixed(1),
            unit: "°C",
            title: "Temperatura",
            difference: temperatureDiff.difference,
            positive: temperatureDiff.positive
          };

          const oxygenData = {
            value: currentOxygen.toFixed(1),
            unit: "mg/L",
            title: "Oxígeno",
            difference: oxygenDiff.difference,
            positive: oxygenDiff.positive
          };

          const dissolvedOxygenData = {
            value: currentDissolvedOxygen.toFixed(1),
            unit: "%",
            title: "Saturación",
            difference: dissolvedOxygenDiff.difference,
            positive: dissolvedOxygenDiff.positive
          };

          const salinityData = {
            value: currentSalinity.toFixed(1),
            unit: "psu",
            title: "Salinidad",
            difference: salinityDiff.difference,
            positive: salinityDiff.positive
          };

          setOxygenData(oxygenData);
          setTemperatureData(temperatureData);
          setSalinityData(salinityData);
          setDissolvedOxygenData(dissolvedOxygenData);
      }
      loadData();
    }else{
      const mockTemperatureData = {
        value: 12.5,
        unit: "°C",
        title: "Temperatura",
        difference: "+0.3",
        positive: true,
      };
      const mockSalinityData = {
        value: 33.2,
        unit: "psu",
        title: "Salinidad",
        difference: "-0.1",
        positive: false,
      };
      const mockOxygenData = {
        value: 68,
        unit: "%",
        title: "Oxígeno Disuelto",
        difference: "+2.1",
        positive: true,
      };

      setTemperatureData(mockTemperatureData);
      setSalinityData(mockSalinityData);
      setOxygenData(mockOxygenData);
    }
  }, [code_siep]);

  const MetricCard = ({ data }) => (
    <Col xs={3}>
      <Card className="rounded-4">
        <CardBody
          className="d-flex flex-column p-3"
          style={{ minHeight: "110px" }}
        >
          <span className="text-muted fw-semibold fs-12">{data?.title}</span>

          <div className="d-flex gap-2 align-items-end mt-1">
            <h3 className="m-0 fw-bold text-dark fs-22">
              {data?.value}
              <span className="fs-16 ms-1">{data?.unit}</span>
            </h3>
            {data?.positive ? (
              <i className="ri-arrow-right-up-line fs-16" style={{ color: '#3EA58A' }}></i>) : (
              <i className="ri-arrow-right-down-line fs-16" style={{ color: '#E25D37' }}></i>)}
          </div>
          <span
            className="fw-bold fs-12"
            style={{ color: data?.positive ? '#3EA58A' : '#E25D37' }}
          >
            {data?.difference}
          </span>
          <span className="text-muted fs-10 mt-1">
            vs. semana anterior
          </span>
        </CardBody>
      </Card>
    </Col>
  );

  return (
    <Row className="g-2">
      <MetricCard data={oxygenData} textClass="text-success" />
      <MetricCard data={dissolvedOxygenData} textClass="text-info" />
      <MetricCard data={temperatureData} textClass="text-primary" />
      <MetricCard data={salinityData} textClass="text-info" />
    </Row>
  );
};

export default LeftSummaryWidget;
